import { makeApiRequest } from '@/src/lib/api-request'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { User } from '@/src/types/user'
import { useMutation } from '@tanstack/react-query'

export const useGoogleLoginMutation = () => {
  const { setRefreshToken, setUser } = useUser()
  const { setToken } = useToken()
  return useMutation({
    mutationKey: ['user', 'google-login'],
    mutationFn: async (params: { authToken?: string, googleCode?: string, redirUrl?: string }) => {
      let data = {
        'googleCode': params.googleCode,
        'redirectURL': params.redirUrl
      }
      const response = await makeApiRequest({
        method: 'POST',
        fallbackError: 'Error while logging in with Google',
        isAuthenticated: false,
        url: params.googleCode ? '/GoogleLogin/signinGoogle_pwa' : '/GoogleLogin/signinGoogle',
        data: params.googleCode ? data : { googleAuth: params.authToken },
        isV3Api: true,
      })

      setToken(response.token)
      setRefreshToken(response.refresh_token)
      setUser(response.response)

      return response.response as User
    },
  })
}
